import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-advanced-filter",
  "use": "icon-advanced-filter-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-advanced-filter\">\n<path d=\"M2.1333 11.9V10.8167H5.8833V11.9H2.1333ZM2.1333 8.48334V7.4H9.87697V8.48334H2.1333ZM2.1333 5.06667V3.98334H13.8666V5.06667H2.1333Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol